import React, { useEffect, useState } from "react";
import FullWidthLayout from "../components/FullWidthLayout";
import { fetchWorkcellStatsGrid } from "../api";
import { formatLocalDate } from "../utils/localDateTime";

const WorkcellStatsGridDemoPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Example date, replace with dynamic date if needed
  // const date = "2024-10-01";
  const date = formatLocalDate(new Date());
  const range_days = 28;

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchWorkcellStatsGrid(date, range_days)
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Error fetching data");
        setLoading(false);
      });
  }, [date, range_days]);

  return (
    <FullWidthLayout>
      <h2>Workcell Stats Grid Demo</h2>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: "red" }}>Error: {error}</div>}
      {!loading && !error && (
        <pre style={{ background: "#f6f8fa", padding: "1em", borderRadius: "6px" }}>
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </FullWidthLayout>
  );
};

export default WorkcellStatsGridDemoPage;
